export enum WebSocketMessageType {
  // A message that indicates an event has occurred. Used to communicate information to all end users on a subscription.
  Event = 'WebsocketMessageType_Event',
  // A message that instructs the recipient to perform a specific action. i.e., reload-products.
  Command = 'WebsocketMessageType_Command',
  // A message that contains updated data of a specific data model.
  DataUpdate = 'WebsocketMessageType_DataUpdate',
  // A message that is used to convey/check the status of a connection.
  ConnectionManager = 'WebsocketMessageType_ConnectionManager',
  // A message that indicates an error has occurred.
  Error = 'WebsocketMessageType_Error',
  // A message that indicates an error has occurred but should NOT fall back to RESTful API call.
  ErrorWithNoRestfulFallback = 'WebsocketMessageType_NonRetryableError',
  // A message that informs the recipient about something.
  Notification = 'WebsocketMessageType_Notification',
  // A message that is a response to a previously sent command. Used to communicate information to a specific user.
  Response = 'WebsocketMessageType_Response'
}
